import React, { useState, useEffect } from "react";
import ButtonContainer from "./buttonContainer";
import TextFieldCustom from "../../../../component/elements/textfieldCustom/index";
import StoreHours from "./StoreHours";
import { validateForm } from "../../../../utils/formValidation/validation";
import { storeDetailsRules } from "../../../../utils/formValidation/validationRules";
import { getLatLngFromZip } from "../../../../utils/latLongFetch";
import { useSnackbar } from "../../../../component/SnackbarContext";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const daysOfWeek = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

const defaultStoreHours = daysOfWeek.reduce((acc, day) => {
  acc[day] = { open: null, close: null, note: "" };
  return acc;
}, {});

function StoreDetails({ nextHandler, previousHandler, mode, formValues }) {
    const showSnackbar = useSnackbar();
  const [formData, setFormData] = useState({
    storeName: "",
    storeContactNumber: "",
    storeLicenseNumber: "",
    addressLine1: "",
    addressLine2: "",
    landmark: "",
    city: "",
    state: "",
    zip: "",
    latitude: "",
    longitude: "",
  });
  const [formErrors, setFormErrors] = useState({});
  const [storeHrErrors, setStoreHrErrors] = useState({});
  const [storeHours, setStoreHours] = React.useState(defaultStoreHours);
  const [applyToAll, setApplyToAll] = React.useState(false);
  const [globalTime, setGlobalTime] = React.useState({
    open: null,
    close: null,
  });

  useEffect(() => {
    if (!formValues || typeof formValues !== "object") return;

    setFormData((prev) => ({ ...prev, ...formValues }));

    // Merge so every weekday exists and we never keep stale rows after refetch / step change.
    if (formValues.storeHours && typeof formValues.storeHours === "object") {
      const merged = { ...defaultStoreHours };
      daysOfWeek.forEach((day) => {
        const row = formValues.storeHours[day];
        if (row && typeof row === "object") {
          merged[day] = {
            open: row.open ?? null,
            close: row.close ?? null,
            note: row.note ?? "",
          };
        }
      });
      setStoreHours(merged);
    } else {
      setStoreHours({ ...defaultStoreHours });
    }
  }, [formValues]);

  const handleTimeChange = (day, type, timeValue) => {
    setStoreHours((prev) => ({
      ...prev,
      [day]: {
        ...prev[day],
        [type]: timeValue,
      },
    }));
  };

  const handleGlobalTimeChange = (type, value) => {
    setGlobalTime((prev) => ({
      ...prev,
      [type]: value,
    }));

    if (applyToAll) {
      const updatedHours = daysOfWeek.reduce((acc, day) => {
        acc[day] = {
          ...storeHours[day],
          [type]: value,
        };
        return acc;
      }, {});
      setStoreHours(updatedHours);
    }
  };

  const handleApplyToAllChange = (event) => {
    const checked = event.target.checked;
    setApplyToAll(checked);

    if (checked && globalTime.open && globalTime.close) {
      const updated = daysOfWeek.reduce((acc, day) => {
        acc[day] = { open: globalTime.open, close: globalTime.close };
        return acc;
      }, {});
      setStoreHours(updated);
    }
  };

  const handleChange = (field) => (e) => {
    const value = e.target?.value ?? e;
    setFormData((prev) => ({ ...prev, [field]: value }));
    setFormErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const handleSubmit = async () => {
    const errors = validateForm(formData, storeDetailsRules);
    setFormErrors(errors);
    
    if (Object.keys(errors).length === 0 && Object.keys(storeHrErrors).length === 0) {
      const hasStoreHours = Object.values(storeHours).some(
        ({ open, close, note }) => open || close || note
      );
      let updatedFormData = { ...formData };
      let latlong = await getLatLngFromZip(formData.zip);
      if (!latlong) {
        showSnackbar("Failed to get location from zip code", "error");
        return;
      }
      updatedFormData.latitude = latlong.latitude;
      updatedFormData.longitude = latlong.longitude;
      updatedFormData = {
        ...updatedFormData,
        ...(hasStoreHours ? { storeHours } : {}),
      };
       if(mode === "edit"){
        updatedFormData ={
          ...updatedFormData,
          ...formValues.address_id,
          ...formValues.latlong_id
        }
      }
      nextHandler(updatedFormData, "store-details");
    }else {
      showSnackbar(
        "Please complete all required fields before continuing.",
        "error"
      );
    }
  };

  return (
    <div>
      <div className="shadow-card py-7 px-6 rounded-[16px]">
        <div className=" grid gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
          <TextFieldCustom
            label="Store Name*"
            value={formData.storeName}
            onChange={handleChange("storeName")}
            error={!!formErrors.storeName}
            helperText={formErrors.storeName || " "}
            fullWidth
          />
          {/* <TextFieldCustom
            label="Store Contact no.*"
            value={formData.storeContactNumber}
            onChange={handleChange("storeContactNumber")}
            error={!!formErrors.storeContactNumber}
            helperText={formErrors.storeContactNumber || " "}
            fullWidth
          /> */}
             <div>
            <PhoneInput
              country={"us"}
              value={formData.storeContactNumber}
              onChange={(val) => handleChange("storeContactNumber")(val)}
              inputClass="!w-full !h-[53px] !border !border-[#d1d5db] !rounded-[10px]"
              containerClass="w-full"
            />
            {formErrors.storeContactNumber && (
              <div className="text-red-600 text-xs mt-1">{formErrors.storeContactNumber}</div>
            )}
          </div>
          <TextFieldCustom
            label="EIN*"
            fullWidth
            value={formData.storeLicenseNumber}
            onChange={handleChange("storeLicenseNumber")}
            error={!!formErrors.storeLicenseNumber}
            helperText={formErrors.storeLicenseNumber || " "}
          />
          <TextFieldCustom
            label="Address*"
            fullWidth
            value={formData.addressLine1}
            onChange={handleChange("addressLine1")}
            error={!!formErrors.addressLine1}
            helperText={formErrors.addressLine1 || " "}
          />

          {/* <TextFieldCustom
            label="Area, Street ,Sector, Village*"
            fullWidth
            value={formData.addressLine2}
            onChange={handleChange("addressLine2")}
            error={!!formErrors.addressLine2}
            helperText={formErrors.addressLine2 || " "}
          /> */}

          <TextFieldCustom
            label="Unit"
            fullWidth
            value={formData.landmark}
            onChange={handleChange("landmark")}
            // error={!!formErrors.landmark}
            // helperText={formErrors.landmark || " "}
          />

          <TextFieldCustom
            label="City/Town*"
            fullWidth
            value={formData.city}
            onChange={handleChange("city")}
            error={!!formErrors.city}
            helperText={formErrors.city || " "}
          />

          <TextFieldCustom
            label="State*"
            fullWidth
            value={formData.state}
            onChange={handleChange("state")}
            error={!!formErrors.state}
            helperText={formErrors.state || " "}
          />

          <TextFieldCustom
            label="Zip code*"
            fullWidth
            value={formData.zip}
            onChange={handleChange("zip")}
            error={!!formErrors.zip}
            helperText={formErrors.zip || " "}
          />
          {/* <TextFieldCustom
            label="Latitude*"
            fullWidth
            value={formData.latitude}
            onChange={handleChange("latitude")}
            error={!!formErrors.latitude}
            helperText={formErrors.latitude || " "}
          />
          <TextFieldCustom
            label="Longitude*"
            fullWidth
            value={formData.longitude}
            onChange={handleChange("longitude")}
            error={!!formErrors.longitude}
            helperText={formErrors.longitude || " "}
          /> */}
        </div>

        <div className="text-[15px] text-[#656565] font-semibold mt-4">
          Store Hours*
        </div>

        <div className="border border-[#B6B4B4] p-5 rounded-[4px] mt-1 ">
          <StoreHours
            applyToAll={applyToAll}
            handleApplyToAllChange={handleApplyToAllChange}
            globalTime={globalTime}
            handleGlobalTimeChange={handleGlobalTimeChange}
            daysOfWeek={daysOfWeek}
            storeHours={storeHours}
            handleTimeChange={handleTimeChange}
             setErrorsInParent={setStoreHrErrors}
          />
        </div>
      </div>
      <ButtonContainer
        handleNext={handleSubmit}
        handlePrevious={previousHandler}
        mode={mode}
      />
    </div>
  );
}

export default StoreDetails;
